import React, { Component } from "react";
import "./SampleDL.scss";
import DLFront from "../../../assets/docSampleImages/DL FRONT.jpg";
import DLBACK from "../../../assets/docSampleImages/DL BACK.jpg";
import { useDialogA11y } from "../../UI/Backdrop/Backdrop";
export interface IViewSampleDLPopup {
  setShowPopup: Function;
  showPopup: boolean;
  text?: any;
  children?: any;
  parentClassName?: string;
}
const SampleDrivingLicensePopup = (props: IViewSampleDLPopup) => {
  const closePopup = () => {
    if (props?.setShowPopup !== undefined) props.setShowPopup(false);
  };
  const dialogRef = useDialogA11y(!!props.showPopup, closePopup);
  const overlayRef = React.useRef<HTMLDivElement>(null);
  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (overlayRef.current && event.target === overlayRef.current) {
        closePopup();
      }
    };

    const timer = setTimeout(() => {
      document.addEventListener("mousedown", handleClickOutside);
    }, 0);

    return () => {
      clearTimeout(timer);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [props?.setShowPopup]);

  return (
    <div
      className={`overlay-DL ${props?.parentClassName ?? ""}`}
      ref={overlayRef}
    >
      <div className="popup-DL" role="dialog" aria-modal="true" aria-labelledby="sample-dl-popup-title" ref={dialogRef}>
        {/* Close Button */}
        <button
          type="button"
          className="close-btn"
          aria-label="Close"
          onClick={closePopup}
        >
          <i className="edel-icon-close" aria-hidden="true" />
        </button>

        <h2 className="popup-title" id="sample-dl-popup-title">Uploading Driving Licence</h2>

        {/* Popup Content */}
        {/* {commonUIView()} */}

        <div className="Aadhar-format-2">
          <span>
            <p className="Aadhar-format-read-more">
              Attach a readable front & back photo of your Driving Licence in
              JPEG or PNG (Max Size: 2MB)
            </p>
            <span className="Aadhar-Front-row">
              <div className="image-container">
                <img
                  src={DLFront}
                  width={130}
                  height={120}
                  className="aadhar-Front-sample document-image" alt="Sample driving license front" />
                <div className="badge">1</div>
              </div>

              <span className="Aadhar-Label">FRONT</span>
            </span>
            <span className="Aadhar-Front-row mt-20">
              <div className="image-container">
                <img
                  src={DLBACK}
                  width={130}
                  height={120}
                  className="aadhar-Front-sample document-image" alt="Sample driving license back" />
                <div className="badge">2</div>
              </div>

              <span className="Aadhar-Label">BACK</span>
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};
export default SampleDrivingLicensePopup;
